// extracted by mini-css-extract-plugin
export var number = "NumberInput-module--number--2YVuk";
export var input = "NumberInput-module--input--3SiSO";